import gql from "graphql-tag";

const FORWARD_PRICE_LIST_TO_EMAIL = gql`
  mutation forwardPriceListToEmail($priceListId: ID!, $email: String!) {
    forwardPriceListToEmail(priceListId: $priceListId, email: $email)
  }
`;

export default FORWARD_PRICE_LIST_TO_EMAIL;
